<template>
  <div id="modal" class="modal modal-esc100" role="dialog">
    <button
      type="button"
      class="btn-close"
      @click="close"
      aria-label="Close modal"
      title="Close"
    >
      ×
    </button>

    <header class="modal-header">
      <h3 class="modal-header-title">{{ computedData.title }}</h3>
    </header>

    <section class="modal-body">
      <div v-html="computedData.intro"></div>

      <p class="modal-body-categories">Our {{ computedData.title }} categories:</p>

      <div class="dropdown__card" v-for="(cat,c) in computedData.categories" :key="c">
        <input class="dropdown-checkbox" type="checkbox" :id="`${cat.title}_${c}`" :name="`${cat.title}_${c}`" :checked="cat.title.toLowerCase() == payload.payload.judged_outcome.toLowerCase()">

        <label class="dropdown-btn" :for="`${cat.title}_${c}`">
          <p>{{ cat.title }}</p>
          <ul class="dropdown-btn-awards">
            <li v-for="stars in cat.stars" :key="stars">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M552 64H448V24c0-13.3-10.7-24-24-24H152c-13.3 0-24 10.7-24 24v40H24C10.7 64 0 74.7 0 88v56c0 35.7 22.5 72.4 61.9 100.7 31.5 22.7 69.8 37.1 110 41.7C203.3 338.5 240 360 240 360v72h-48c-35.3 0-64 20.7-64 56v12c0 6.6 5.4 12 12 12h296c6.6 0 12-5.4 12-12v-12c0-35.3-28.7-56-64-56h-48v-72s36.7-21.5 68.1-73.6c40.3-4.6 78.6-19 110-41.7 39.3-28.3 61.9-65 61.9-100.7V88c0-13.3-10.7-24-24-24zM99.3 192.8C74.9 175.2 64 155.6 64 144v-16h64.2c1 32.6 5.8 61.2 12.8 86.2-15.1-5.2-29.2-12.4-41.7-21.4zM512 144c0 16.1-17.7 36.1-35.3 48.8-12.5 9-26.7 16.2-41.8 21.4 7-25 11.8-53.6 12.8-86.2H512v16z"/></svg>
            </li>
          </ul>
          <div class="dropdown-btn-arrow">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
            </svg>
          </div>
        </label>

        <div class="dropdown-body">
          <div v-html="cat.desc"></div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
  export default {  
    name: 'EscapeScore',

    props: {
    	payload: {
    		type: Object
    	}
    },

    data() {
      return {
        popups: {
          'Impact': {
            title: 'Impact',
            intro: `<p>Our “Impact” measure is the foundation of our judging criteria. Not only does it denote how far-reaching the organisation’s work is in the world, but it also affects both the “Mission” and “Planet” criteria.</p>
                    <p>An organisation’s mission is multiplied if its impact is far-reaching. Similarly, an organisation’s environmental footprint is multiplied by its scale. In this way, the impact criteria has an important bearing on our calculation.</p>`,
            categories: [
              {
                title: 'Just Starting',
                desc: `<p>This organisation is just starting out. Their current reach is relatively low, but growing.</p>`,
                stars: 1
              },
              {
                title: 'Local',
                desc: `<p>This organisation mostly operates within a single Town or City. c 90% of their customers are localised.</p>`,
                stars: 1
              },
              {
                title: 'Predominantly Remote',
                desc: `<p>This organisation is a remote e-commerce / tech company without a physical presence.</p>`,
                stars: 2
              },
              {
                title: 'National',
                desc: `<p>This organisation has nationwide operations. They have operations and team members across multiple domestic locations.</p>`,
                stars: 2
              },
              {
                title: 'Transnational',
                desc: `<p>This organisation has operations and team members in 2 - 5 countries.</p>`,
                stars: 3
              },
              {
                title: 'Global',
                desc: `<p>This organisation has operations and offices spread across more than 5 countries.</p>`,
                stars: 3
              },
            ],
          },
          'Mission': {
            title: 'Mission',
            intro: `<p>Fundamentally, what is their reason for being? Some are simply driven by selling products to make money, others are charities that exist primarily to address a social or environmental need. And many fall somewhere in-between, focusing both on the products and services they provide, and on tackling wider societal and environmental issues.</p>
                    <p><strong>All organisations solve a problem - How do you decide which issue are the most important?</strong></p>
                    <p>We used the United Nations Sustainable Development Goal (SDG) Framework of 17 key issues which most urgently need to be addressed for a socially and environmentally sustainable world. Along with these, we identified a number of other important issues that sit outside of the SDG framework and put all of these together on a scale.</p>`,
            categories: [
              {
                title: 'Other',
                desc: `<p>This organisation’s primary purpose is to solve a problem which we do not support.</p>
                      <p>For more information on how we categorise an organisation's mission, view our latest <a href="https://docs.google.com/spreadsheets/d/1EwMr_KwUtEN8YnlKs8enI9CspGB-pYtgPg9KVT3UWfk/edit" target="_blank">"Missions We Support: 2022" list.</a></p>`,
                stars: 0
              },
              {
                title: 'Better business',
                desc: `<p>This organisation’s primary purpose is to solve a problem which we support.</p>
                        <p>For more information on how we categorise an organisation's mission, view our latest <a href="https://docs.google.com/spreadsheets/d/1EwMr_KwUtEN8YnlKs8enI9CspGB-pYtgPg9KVT3UWfk/edit" target="_blank">"Missions We Support: 2021" list.</a></p>`,
                stars: 2
              },
              {
                title: 'Business for good',
                desc: `<p>This organisation is working towards solving an important problem that falls outside of the United Nations Sustainable Development Goals.</p>
                      <p>For more information on how we categorise an organisation's mission, view our latest <a href="https://docs.google.com/spreadsheets/d/1EwMr_KwUtEN8YnlKs8enI9CspGB-pYtgPg9KVT3UWfk/edit" target="_blank">"Missions We Support: 2021" list.</a></p>`,
                stars: 1
              },
              {
                title: 'Supporting a better future',
                desc: `<p>This organisation’s work is contributing towards solving one or more of the problems as identified by the United Nation Sustainable Development Goals, but it is not explicitly their primary purpose.</p>
                      <a href="https://sdgs.un.org/" target="_blank">
                        <img alt="" src="/images/methodology/mission-scale.jpg" loading="lazy">
                      </a>
                      <p>Click on the image above to find out more.</p>`,
                stars: 2
              },
              {
                title: 'Fixing the future',
                desc: `<p>This organisation’s primary purpose is to solve a problem identified in one of the 17 United Nation Sustainable Development Goals.</p>
                      <a href="https://sdgs.un.org/" target="_blank">
                        <img alt="" src="/images/methodology/mission-scale.jpg" loading="lazy">
                      </a>
                      Click on the image above to find out more.`,
                stars: 3
              }
            ],
          },
          'Planet': {
            title: 'Planet',
            intro: `<p>The world needs organisations not only to be more conscious but to find solutions to the challenges we face.We are living through a climate emergency. From the Paris Climate Agreement, to Extinction Rebellion and school strikes, to the resurgence of renewable energy and ‘green politics’, environmental concerns are now unavoidable. We believe all businesses, no matter how big or small, need to commit to having a positive impact on our planet.</p>`,
            categories: [
              {
                title: 'Work in progress',
                desc: `<p>The organisation has a negative environmental impact with few environmental policies in place.</p>`,
                stars: 0
              },
              {
                title: 'Conscientious of the planet',
                desc: `<p>This organisation currently has a negative environmental impact through their production or operations but is explicitly working towards becoming planet-neutral and has goals and deadlines to meet those goals.</p>`,
                stars: 0
              },
              {
                title: 'Low Impact',
                desc: `<p>These organisations business models and operations inherently are low impact e.g. Digital Services, Agencies, Consultancies. This includes fully remote teams which don\'t require frequent travel or commuting.</p>`,
                stars: 1
              },
              {
                title: 'Great for the planet',
                desc: `<p>The organisation\'s environmental impact is carbon neutral. This is based on proactive carbon offsetting.</p>`,
                stars: 2
              },
              {
                title: 'Exceptional for the planet',
                desc: `<p>This organisation is actively making a positive environmental impact on the world. Things taken into account: their product or services impact on the environment, their energy use and source, their recycling programmes, and their measurement and proactive mitigation of any emissions.</p>`,
                stars: 3
              }
            ],
          },
          'People': {
            title: 'People',
            intro: `<p>You can have the most heartfelt mission, a world-beating strategy but creating an engaging workplace is an entirely different matter. Employees need organisations to set them up for success.</p>
                    <p>But how do you measure it?</p>
                    <p>We did this in two ways, one was to ask the employees themselves.</p>
                    <p>"To what extent do you recommend this organisation as a place to work?"</p>
                    <p>Employees at all participating organisations were given an anonymous link and asked to rate their organisation as a place to work on a scale of 1 - 10.</p>
                    <p>Organisations were judged not only on their average score but also by how many of their employees participated.</p>`,
            categories: [
              {
                title: 'Solid for employees',
                desc: `<p>These organisations have a number of solid policies aimed at developing and looking after their staff.</p>`,
                stars: 0
              },
              {
                title: 'Good for employees',
                desc: `<p>These organisations scored third highest in relation to how they look after the people working in their organisations. They had a number of important policies geared towards supporting their teams.</p>`,
                stars: 1
              },
              {
                title: 'Great for employees',
                desc: `<p>These organisations scored the second highest points in relation to how they look after the people working in their organisations. Organisations in this category prioritised employee training, paying the living wage, as well as focusing on inclusion and diversity.</p>`,
                stars: 2
              },
              {
                title: 'Exceptional for employees',
                desc: `<p>These organisations scored the highest points in relation to how they look after the people working in their organisations. These organisations had the highest number of policies and practices which encompass personal and professional development, equitable pay, diverse and inclusive leadership and hiring, employee empowerment, diverse leadership and growth.</p>`,
                stars: 3
              },
            ],
          },
          'People2': {
            title: 'People',
            intro: `<p></p>
                    <p></p>
                    <p></p>
                    <p></p>
                    <p></p>
                    <p></p>`,
            categories: [
              {
                title: 'Not enough reviews',
                desc: `<p>The organisation didn\'t receive enough reviews to be counted for the people score.</p>`,
                stars: 0
              },
              {
                title: '<7',
                desc: `<p>The average score employees gave was less than 7 / 10.</p>`,
                stars: 0
              },
              {
                title: '7-8',
                desc: `<p>The average employee score was between 7-8 / 10</p>`,
                stars: 0
              },
              {
                title: '8-9',
                desc: `<p>The average employee score was 8+.</p>`,
                stars: 1
              },
              {
                title: '9 - 9.4',
                desc: `<p>The average employee score was 9.0 - 0.4 /10.</p>`,
                stars: 2
              },
              {
                title: '9.5+',
                desc: `<p>Top score. The employees scored this organisation above 9.5 / 10! A truly remarkable score.</p>`,
                stars: 3
              },
            ],
          },
          'Innovation': {
            title: 'Innovation',
            intro: `<p>The world needs organisations to do things differently. Innovation is more than just a quirk of originality though - it inspires the world and sparks progress by providing creative solutions to pervasive problems. There is an element of real excitement about working somewhere which throws a spanner in the machine and builds a truly unique solution from scratch. This criterion celebrates the different, the unique, and the damn-right whacky concepts that inspire us.</p>`,
            categories: [
              {
                title: 'Challenger',
                desc: `<p>While this organisation may have innovative methods, customers, or business practices, its main offering is traditional.</p>`,
                stars: 1
              },
              {
                title: 'Disruptor',
                desc: `<p>Part of a small but growing group of organisations doing things differently in their industry.</p>`,
                stars: 2
              },
              {
                title: 'Game changer',
                desc: `<p>The only (one of a select few) highly disruptive organisation(s) in their industry. They have a completely unique approach to solving a problem.</p>`,
                stars: 3
              }
            ],
          },
          'B Corp': {
            title: 'B Corp',
            intro: `<p>Certified B Corporations are businesses that meet the highest standards of verified social and environmental performance, public transparency, and legal accountability to balance profit and purpose. B-Corps form a community of leaders and drive a global movement of people using business as a force for good.</p>
                    <p>Think of it as an ethical badge of honour. The B-Corp certification process sets the highest standards for 21st Century Businesses. Bcorps represent a sustainable, thoughtful economy, rigorously measured and held to account which is why a bcorp would achieve maximum points for this section.</p>`,
            categories: [
              {
                title: 'B Corp',
                desc: `<p>The organisation is B-Corp Certified.</p>`,
                stars: 0
              },
              {
                title: 'Pending b corp',
                desc: `<p>The organisation is pending B-Corp Certification.</p>`,
                stars: 0
              },
              {
                title: 'Charity',
                desc: `<p>This organisation is a charity, so are not eligible for B Corp certification.</p>`,
                stars: 0
              },
              {
                title: 'Neither',
                desc: `<p>The organisation is not B-Corp Certified.</p>`,
                stars: 0
              }
            ],
          },
        }
      }
    },

    methods: {
      close() {
        this.$emit('close')
      },
    },

    computed: {
      computedData() {
        return this.popups[this.payload.payload.category];
      }
    }
  };
</script>
